<div class="bg-white rounded-2xl border border-slate-200/90 p-4 sm:p-5 shadow-xs flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
  <!-- Chart.js Donut Ring with Center Percentage -->
  <div class="relative w-24 h-24 sm:w-28 sm:h-28 shrink-0 flex items-center justify-center">
    <canvas #chartCanvas class="w-full h-full block"></canvas>
    <div class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none select-none text-center">
      <span class="text-xl sm:text-2xl font-bold text-slate-900 leading-none tracking-tight">
        {{ matchPercentage }}%
      </span>
      <span class="text-[11px] sm:text-xs font-normal text-slate-400 mt-1 leading-none">
        {{ matchLabel }}
      </span>
    </div>
  </div>

  <!-- 3 Metric Columns -->
  <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 flex-1 min-w-0 w-full sm:w-auto">
    <!-- SuperSee Tracked -->
    <div class="flex flex-col justify-center min-w-0">
      <span class="text-xs sm:text-sm font-normal text-slate-500 truncate leading-tight">
        Tracked by SuperSee
      </span>

      <div *ngIf="isLoading" class="py-1">
        <ngx-skeleton-loader count="1"
          [theme]="{ 'border-radius': '6px', height: '24px', width: '80px', 'margin-bottom': '4px', margin: '0' }">
        </ngx-skeleton-loader>
        <ngx-skeleton-loader count="1"
          [theme]="{ 'border-radius': '4px', height: '12px', width: '110px', margin: '4px 0 0 0' }">
        </ngx-skeleton-loader>
      </div>

      <ng-container *ngIf="!isLoading">
        <div class="text-xl sm:text-2xl font-bold text-slate-900 leading-tight mt-1 truncate">
          {{ displayDesktopTime }}
        </div>
        <div class="text-xs text-slate-400 truncate mt-1 leading-tight" [matTooltip]="desktopTimeSubtitle">
          {{ displayDesktopSubtitle }}
        </div>
      </ng-container>
    </div>

    <!-- Conduct Logged -->
    <div class="flex flex-col justify-center min-w-0">
      <span class="text-xs sm:text-sm font-normal text-slate-500 truncate leading-tight">
        Logged on Conduct
      </span>
      <div class="text-xl sm:text-2xl font-bold text-slate-900 leading-tight mt-1 truncate">
        {{ displayConductTime }}
      </div>
      <div class="text-xs text-slate-400 truncate mt-1 leading-tight">
        {{ tasksSubtitle }}
      </div>
    </div>

    <!-- Unlogged -->
    <div class="flex flex-col justify-center min-w-0">
      <span class="text-xs sm:text-sm font-normal text-slate-500 truncate leading-tight">
        Unlogged
      </span>

      <div *ngIf="isLoading" class="py-1">
        <ngx-skeleton-loader count="1"
          [theme]="{ 'border-radius': '6px', height: '24px', width: '70px', 'margin-bottom': '4px', margin: '0' }">
        </ngx-skeleton-loader>
        <ngx-skeleton-loader count="1"
          [theme]="{ 'border-radius': '4px', height: '12px', width: '90px', margin: '4px 0 0 0' }">
        </ngx-skeleton-loader>
      </div>

      <ng-container *ngIf="!isLoading">
        <div class="text-xl sm:text-2xl font-bold leading-tight mt-1 truncate" [ngClass]="unloggedTextColorClass">
          {{ displayUnloggedTime }}
        </div>
        <div class="text-xs text-slate-400 truncate mt-1 leading-tight">
          {{ gapsSubtitle }}
        </div>
      </ng-container>
    </div>
  </div>
</div>
